<template>
    <!-- Page Content Wrapper -->
    <div v-if="permissionsArray.includes('can_manage_users')" id="page-content-wrapper" class="admin-content-area cl">
        <div class="container-fluid xyz location-listing">
            <div class="page-header-top-container cusinventory-list-header" style="position: fixed;">
                <h1 class="page-title"> Consigned Inventory List </h1>
                <!-- <button type="submit" v-on:click.prevent="addInventory()" class="btn btn-primary waves-effect pull-right">Add</button> -->
                <template v-if="!isUniversalSearch && totalExtCost != 0">
                    <div class="ext-cost pull-right" style="padding-top: 15px;">Total ExtCost: {{totalExtCost}}</div>
                    <!-- <button type="submit" id='refreshList' title='Refresh' class="extraFeature btn btn-primary waves-effect pull-right ml-2" v-on:click.prevent="loadInventory()">
                        <i class="fa fa-rotate-right" aria-hidden="true"></i>
                    </button> -->
                </template>
            </div>

            <!--page content-->
            <div class="admin-page-content cusinventory-list-pagecont" style="padding-top: 80px;">
                <div class="app-filter-good-table-container text-align-placeholder-list-inventory">
                    <!-- @on-cell-click="onCellClick" -->
                    <vue-good-table
                        ref="listInventory"
                        mode="remote"
                        title="Inventory"
                        @on-page-change="onPageChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :selectOptions="selectOptions"
                        :pagination-options="{
                            enabled: true,
                            mode: 'pages',
                            pageLabel: 'Page',
                            position: 'both',
                            perPage: serverParams.perPage,
                            setCurrentPage: serverParams.setCurrentPage,
                            perPageDropdown: [25, 50, 100, 200 ,500],
                            dropdownAllowAll: false,
                        }"
                        :search-options="{
                            enabled: false,
                        }">

                        <!-- Custome Pagination -->
                        <template slot="pagination-top" slot-scope="props">
                            <div class="vgt-wrap__footer top-pagination crm">
                                <div  class="row">
                                    <div class="col-sm-12 col-md-2 PerPage">
                                        <v-select title="Select Per Page"
                                            v-model="serverParams.perPage"
                                            @change="changedValueTask"
                                            @input="changedValueTaskCustomPerPageTask()"
                                            name="customPerPage"
                                            id="customPerPage"
                                            label="text"
                                            :clearable="false"
                                            :searchable="false"
                                            :filterable="false"
                                            :options="serverParams.perPageDropdown"
                                            placeholder="Select Per Page">
                                        </v-select>
                                    </div>
                                    <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                        <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                    </div>
                                    <div class="col-sm-12 col-md-6 Pagination">
                                        <ul class="pagination">
                                            <li class="FirstPage" title="First Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                            </li>
                                            <li class="page-item PreviousPage" title="Previous Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                </template>
                                            </li>
                                            <!--New Implementation-->
                                            <template v-if="pageNumberListTask() < displayPageTask">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <!--End New Implementation-->
                                                <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                    <template v-for="(n, index) in displayPageTask">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                    <template v-for="(n, index) in pageNumberListTask()">
                                                        <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <li class="page-item NextPage" title="Next Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                            </li>
                                            <li class="LastPage" title="Last Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <p class="pageJumpLabel">Page : </p>
                                    </div>
                                    <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- End Custome Pagination -->

                        <!-- Custome Pagination -->
                        <template slot="pagination-bottom" slot-scope="props">
                            <div class="vgt-wrap__footer crm">
                                <div  class="row">
                                    <div class="col-sm-12 col-md-2 PerPage">
                                        <v-select title="Select Per Page"
                                            v-model="serverParams.perPage"
                                            @change="changedValueTask"
                                            @input="changedValueTaskCustomPerPageTask()"
                                            name="customPerPage"
                                            id="customPerPage"
                                            label="text"
                                            :clearable="false"
                                            :searchable="false"
                                            :filterable="false"
                                            :options="serverParams.perPageDropdown"
                                            placeholder="Select Per Page">
                                        </v-select>
                                    </div>
                                    <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                        <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                    </div>
                                    <div class="col-sm-12 col-md-6 Pagination">
                                        <ul class="pagination">
                                            <li class="FirstPage" title="First Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                            </li>
                                            <li class="page-item PreviousPage" title="Previous Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                </template>
                                            </li>
                                            <!--New Implementation-->
                                            <template v-if="pageNumberListTask() < displayPageTask">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <!--End New Implementation-->
                                                <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                    <template v-for="(n, index) in displayPageTask">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                    <template v-for="(n, index) in pageNumberListTask()">
                                                        <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <li class="page-item NextPage" title="Next Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                            </li>
                                            <li class="LastPage" title="Last Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <p class="pageJumpLabel">Page : </p>
                                    </div>
                                    <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- End Custome Pagination -->

                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <div v-if="props.column.field == 'action' && !isViewOnly">
                                    <router-link class="btn edit-btn-vvg waves-effect" title="Use Part" v-bind:to="{name: 'CustomerUseParts', query:{isEdit: 'No'}, params:{id:props.row.id, name: props.row.strip_part_no, isFrom: 'parts'}}">
                                        <img src="/static/images/cart-img.png" alt="Shopping Cart" class="table-cart">
                                    </router-link>
                                </div>
                                <div v-else-if="props.column.field == 'inventory_part_mapper_bin_location'">
                                    <template v-if="isEditBinLocation">
                                        <input type="text" v-model="props.row.inventory_part_mapper_bin_location" v-on:blur="addUpdateBinLocation(props.row.id, props.row.inventory_part_mapper_bin_location)"/>
                                    </template>
                                    <template v-else>
                                        {{props.formattedRow['inventory_part_mapper_bin_location']}}
                                    </template>
                                </div>
                                <div v-else>
                                    <div v-if="props.column.field != 'inventory_part_mapper_bin_location'">
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <!-- <b-btn v-b-modal.modallg variant="primary" class="btn btn-success" title="Change Bin Location">Change Bin Location</b-btn> -->
                            <b-btn v-if="isShowCheckbox" v-b-modal.ci-modal-lg variant="primary" class="btn btn-success" title="Edit Multiple" v-on:click.prevent="getPartsSelected()"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Multi-Edit ({{$refs["listInventory"].selectedRows.length}})</b-btn>
                        </div>
                    </vue-good-table>
                </div>

                <!--Large Modal-->
                <div class="large-modal">
                    <!--Large Modal Popup-->
                    <b-modal ref="my-modal" id="modallg" size="lg" title="Large Modal" class="modal-section">
                        <form>
                            <div class="form-group">
                                <label for="message-text" class="col-form-label">Bin Loation:</label>
                                <input type="text" v-model="binLocationDataModal" class="form-control" id="message-text" placeholder="Enter Bin Location">
                            </div>
                        </form>
                        <b-button type="button" class="btn btn-primary" v-on:click="addUpdateBinLocation(0, binLocationDataModal)">Submit</b-button>
                    </b-modal>
                    <!--Large Modal Popup-->
                </div>
                <!-- Large Modal -->

                <!--Extra Large Modal-->
                <div class="extra-large-modal">
                    <!--Extra Large Modal Popup-->
                    <b-modal ref="multy-order-part-modal" id="ci-modal-lg" size="lg" title="Edit Multiple Order Part" class="modal-section multy-parts-model" hide-footer>
                        <b-container>
                            <b-row>
                                <b-col cols="12">
                                    <b-form-group>
                                        <label for="po-number-text" class="col-form-label">PO Number : </label>
                                        <div class="form-input">
                                            <input type="text" v-model="poNumber" class="form-control" id="po-number-text" placeholder="Enter PO Number" @input="poNumberError=''" maxlength="13">
                                            <div class="requiredstar">*</div>
                                        </div>
                                        <div class="text-danger qty-on-hand-error">{{ poNumberError }}</div>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <template v-for="(partMap, index) in partsArr">
                                <b-row :key="'Part Data ' + index">
                                    <b-col cols="6">
                                        <b-form-group>
                                            <label for="part-text" class="col-form-label">Part :</label>
                                            <input type="text" v-model="partMap.strip_part_no" class="form-control" id="part-text" disabled>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="6">
                                        <b-form-group>
                                            <label for="qty-text" class="col-form-label">Qty :</label>
                                            <div class="form-input">
                                                <input type="text" v-model="partMap.qty" class="form-control" id="qty-text" placeholder="Enter Qty" @input="partMap.qty_error=''">
                                                <div class="requiredstar">*</div>
                                            </div>
                                            <div class="qty-on-hand-lbl">Qty on Hand : {{partMap.qoh}} </div>
                                            <div class="text-danger qty-on-hand-error">{{ partMap.qty_error }}</div>                                
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </template>
                            <b-button type="button" class="btn btn-danger ci-model-btn" v-on:click.prevent="closeModel">Cancel</b-button>
                            <b-button type="button" class="btn btn-success mr-2 ci-model-btn" v-on:click.prevent="addUpdateMultipleParts">Submit</b-button>
                        </b-container>
                    </b-modal>
                    <!--Extra Large Modal Popup-->
                </div>
                <!-- Extra Large Modal -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <div v-else>
        <no-permission></no-permission>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from "vue";
    import Footer from "@/components/partials/CustomerFooter";
    import EventBus from ".././event-bus";
    import { commonMixins } from "../../mixins/commonMixins";
    import { HTTP } from "../../http-common.js";
    import VueGoodTable from "vue-good-table";
    import NoAccessPermission from '../NoAccessPermission';
    import vSelect from 'vue-select';
    import moment from 'moment';
    import timezone from 'moment-timezone';

    Vue.use(VueGoodTable);
    export default {
        name: "listInventory",
        components: {
            "app-footer": Footer,
            "no-permission" : NoAccessPermission,
            'v-select': vSelect,
        },
        mixins: [commonMixins],
        data() {
            return {
                roleId: 0,
                firstLoad: 0,
                isUniversalSearch: false,
                totalExtCost: 0,
                isEditBinLocation: false,
                binLocationDataModal: "",
                columns: [
                    /* {
                        label: "Name",
                        field: "name",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Location",
                        field: "location_name",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Actions",
                        field: "action",
                        html: true,
                        sortable: false,
                        thClass: "disable-sorting"
                    } */
                    {
                        label: "Part Number",
                        field: "part_no",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Des',
                        field: 'part_des',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Des", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Bin Location',
                        field: 'inventory_part_mapper_bin_location',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Bin Location", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Max Qty',
                        field: 'inventory_max_qty',
                        filterable: true,
                        type: "number",
                        hidden: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Max Qty", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'QOH',
                        field: 'inventory_qty',
                        filterable: true,
                        type: "number",
                        hidden: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "QOH", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /* {
                        label: 'Current QOH',
                        field: 'inventory_qty',
                        filterable: true,
                        type: "number",
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "QOH", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, */
                    {
                        label: 'Unit Cost',
                        field: 'part_unit_price',
                        filterable: true,
                        type: "number",
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Unit Cost", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'ExtCost',
                        field: 'part_ext_price',
                        filterable: false,
                        type: "number",
                        html: true,
                        sortable: false,
                        thClass: "disable-sorting"
                    },
                    /* {
                        label: 'Threshold Qty',
                        field: 'inventory_threshold_qty',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Threshold Qty", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated At',
                        field: 'inventory_part_mapper_updated_at',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, */
                    {
                        label: 'Part Last Used',
                        field: "part_last_used_date",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        sortable: false,
                        hidden: false,
                        thClass: 'disable-sorting',
                    }
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 'All',
                    sort: {
                        field: "id",
                        type: "desc"
                    },
                    perPageDropdown : [],
                },
                recordsCounts: "",
                selectedRows: 0,
                permissionsArray: ['can_manage_users'],

                displayPageTask: 7,
                jumpToPageTask: 0,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
                poNumber : '',
                poNumberError : '',
                partsArr : [
                    {
                        strip_part_no : '',
                        qty : 0,
                        qoh : '',
                        qty_error : '',
                    }
                ],
                partDataModal: "",
                qtyDataModal: "",
                poNumberDataModal: "",
                selectOptions : {
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                },
                isShowCheckbox : false,
                isViewOnly: false
            };
        },
        beforeMount: function() {
            self = this;
            EventBus.$emit("customer-menu-selection-changed", "list-inventory");
        },
        mounted: function() {
            $(window).resize(function () {
                self.windowWidth = $(window).width();
                /* if (self.windowWidth > 767) {
                    $('.contacttDetails').hide();
                } else {
                    $('.contacttDetails').show();
                } */
                // $('.cl .admin-page-content.sticky .vgt-responsive').height($(window).height() - 300);
            });
            //self.getUserRole();
            //self.getUserPermissions();
            /* Header Stick Script Start */
            // $(document).ready(function() {
            //     if ($(this).scrollTop() > 1){  
            //         $('.cl-header').addClass("sticky");
            //     }
            // });
            // $(window).scroll(function() {
            //     if ($(this).scrollTop() > 1){  
            //         $('.cl-header').addClass("sticky");
            //     } else {
            //         $('.cl-header').removeClass("sticky");
            //     }
            // });
            /* setTimeout(function(){
                var stickyTop12 = 77;
                $(window).scroll(function () {
                    var windowTop = $(window).scrollTop();
                    var el = $('.admin-page-content');
                    if (el.length > 0) {
                        if (stickyTop12 < windowTop && !el.is('.sticky') && $(el).outerHeight() > ($(window).height() - 235)) {
                            el.addClass('sticky');
                            $('.cl .admin-page-content.sticky .vgt-responsive').height($(window).height() - 310);
                            $('#page-content-wrapper').addClass('sticky-footer');
                        }
                        else if (stickyTop12 > windowTop && el.is('.sticky')) {
                            el.removeClass('sticky');
                            $('.cl .admin-page-content .vgt-responsive').removeAttr('style');
                            $('#page-content-wrapper').removeClass('sticky-footer');
                        }
                    }
                });
            },500); */
            /* Header Stick Script End */

            self.customerProtal();

            this.jumpToPageTask = this.serverParams.page;
            this.pageCompareTask = Math.ceil(this.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPageTask(self.jumpToPageTask)
                }
            });

            this.serverParams.perPageDropdown.push(25);
            this.serverParams.perPageDropdown.push(50);
            this.serverParams.perPageDropdown.push(100);
            this.serverParams.perPageDropdown.push(200);
            this.serverParams.perPageDropdown.push(500);
            this.serverParams.perPageDropdown.push('All');
            if(localStorage.getItem("login_role") == 'user') {
                for(var i = 0; i < self.columns.length;i++) {
                    if (self.columns[i].field == "action") {
                        self.$set(self.columns[i], 'hidden', true);
                    }
                }
                // Hide checkbox 
                self.selectOptions = {
                    enabled: false,
                    selectOnCheckboxOnly: true, 
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                };
                self.isShowCheckbox = false;
            } else {
                // Show checkbox 
                self.selectOptions = {
                    enabled: true,
                    selectOnCheckboxOnly: true,
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                };
                self.isShowCheckbox = true;
            }

            self.isUniversalSearch = false;
            if (typeof(self.$route.params.name) != "undefined" && self.$route.params.name != "" && self.$route.params.name != '') {
                self.filterValue(self.$route.params.name);
            } else if(localStorage.getItem("universalSearch") && localStorage.getItem("universalSearch") != '') {
                self.filterValue(localStorage.getItem("universalSearch"));                
            } else {
                localStorage.removeItem("universalSearch");
                for(var i = 0; i < self.columns.length;i++){
                    if (self.columns[i].field == "inventory_max_qty"){
                        self.$set(self.columns[i], 'hidden', false);
                    }
                    if (self.columns[i].field == "part_ext_price"){
                        self.$set(self.columns[i], 'hidden', false);
                    }
                }
                self.loadInventory();
            }
            self.isViewOnly = JSON.parse(localStorage.getItem('view_only'));
        },
        methods: {
            filterValue: function(filterData) {
                self.isUniversalSearch = true;
                localStorage.removeItem("universalSearch");
                for(var i = 0; i < self.columns.length;i++){
                    if (self.columns[i].field == "part_no"){
                        self.columns[i].filterOptions.filterValue = filterData;
                    }
                    /* if (self.columns[i].field == "inventory_qty"){
                        self.columns[i].label = "QOH";
                    } */
                    if (self.columns[i].field == "inventory_max_qty"){
                        self.$set(self.columns[i], 'hidden', true);
                    }
                    if (self.columns[i].field == "part_ext_price"){
                        self.$set(self.columns[i], 'hidden', true);
                    }
                }
                self.loadInventory();
            },
            jumpToPageInTask: function (e) {
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function () {
                self.jumpToInputPageTask(self.serverParams.page);
                self.loadInventory();
            },
            changedValueTask: function (value) {
                /*console.log(value);*/
            },
            pageNumberListTask: function () {
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function (pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                self.serverParams.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                self.loadInventory();
            },
            changeStatusUser : function(userId) {
                var inventoryArr = [];
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    }
                };

                var fields = {
                    user_id: userId
                };

                self.$swal({
                        title: "Are you sure?",
                        text: "You want to change the status",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes Change it!",
                        cancelButtonText: "No, Keep it!",
                        showCloseButton: true,
                        showLoaderOnConfirm: true
                    })
                    .then(result => {
                        if (result.value) {
                            HTTP.post("/user/change-user-status", fields, config)
                                .then(function(response) {
                                    self.loadInventory();
                                })
                                .catch(function(err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        }

                    });
            },
            addInventory: function() {
                self.$router.push({name:'AddInventory'});
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({ page: params.currentPage });
                self.loadInventory();
            },
            //
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({ perPage: params.currentPerPage });
                    self.totalRecords = self.totalRecords;
                    self.loadInventory();
                }
            },
            onCellClick(params) {
                if(localStorage.getItem("login_role") != 'user') {
                    self.isEditBinLocation = true;
                } else {
                    self.isEditBinLocation = false;
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: "id";
                    field: "name";
                    field: "location_name";
                    field: "part_last_used_date";
                }
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (
                    self.firstLoad == 1 ||
                    filters.id ||
                    filters.name ||
                    filters.location_name ||
                    filters.part_last_used_date 
                ) {
                    self.loadInventory();
                }
            },
            selectionChanged() {
                self.selectedRows = self.$refs["listInventory"].selectedRows.length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field
                    }
                });
                self.loadInventory();
            },
            addUpdateBinLocation: function(id, binLocationData) {
                self.isEditBinLocation = false;
                var binLocationInventoryArr = [];
                if (id) {
                    binLocationInventoryArr.push(id);
                } else {
                    var selectedUser = this.$refs["listInventory"].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        binLocationInventoryArr.push(this.$refs["listInventory"].selectedRows[i].id);
                    }
                }
                var config = {
                };
                var fields = {
                    inventory_id_arr: binLocationInventoryArr,
                    bin_location: binLocationData,
                };
                HTTP.post("add/update/binlocation", fields, config)
                    .then(function(response) {
                        self.loadInventory();
                    })
                    .catch(function(err) {
                        self.$refs['my-modal'].hide();
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.clear();
                                self.$router.push("/");
                            }
                        }
                    });
            },
            deleteInventory: function(id) {
                var inventoryArr = [];
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    }
                };

                if (id) {
                    inventoryArr.push(id);
                } else {
                    var selectedUser = this.$refs["listInventory"].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        inventoryArr.push(this.$refs["listInventory"].selectedRows[i].id);
                    }
                }
                var fields = {
                    deleteArr: inventoryArr
                };

                self.$swal({
                        title: "Are you sure?",
                        text: "You can't revert your action",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes Delete it!",
                        cancelButtonText: "No, Keep it!",
                        showCloseButton: true,
                        showLoaderOnConfirm: true
                    })
                    .then(result => {
                        if (result.value) {
                            HTTP.post("delete-inventory", fields, config)
                                .then(function(response) {
                                    self.loadInventory();
                                })
                                .catch(function(err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.clear();
                                            self.$router.push("/");
                                        }
                                    }
                                });
                            self.$swal("Deleted", "You successfully deleted record(s)", "success");
                        } else {
                            self.$swal("Cancelled", "Your file is still intact", "info");
                        }
                    });
            },

            closeModel : function() {
                self.resetCIMultiEditModel();
                self.$refs['multy-order-part-modal'].hide();
            },

            getPartsSelected: function() {
                self.resetCIMultiEditModel();
                self.$refs['multy-order-part-modal'].show();
                
                var partsSelectedArr = [];
                
                var selectedCI = this.$refs["listInventory"].selectedRows;
                for (var i = 0; i < selectedCI.length; i++) {
                    partsSelectedArr.push(this.$refs["listInventory"].selectedRows[i].strip_part_no);
                }

                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    }
                };
                var fields = {
                    part_selected_arr: partsSelectedArr
                };

                HTTP.post("inventory/get-multiple-part-by-ids", fields, config)
                    .then(function(response) {
                        if (response.status == "200") {
                            self.partsArr = response.data.content;
                        }
                        if(response.status == "201") {
                            if(self.partsArr.length == 0) {
                                self.$refs['multy-order-part-modal'].hide();
                                self.showSAlert('QOH of selected part must exceed zero', 'info', false);
                                self.loadInventory();
                            }
                        }
                    })
                    .catch(function(err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.clear();
                                self.$router.push("/");
                            }
                        }
                    });
            },

            allnumeric : function (inputtxt) {
                var numbers = /^\d+$/;;
                if(numbers.test(inputtxt)) {
                    return true;
                } else {
                    return false;
                }
            },

            checkForm: function () {
                var checked = true;
                self.poNumberError = "";

                if (!self.poNumber) {
                    self.poNumberError = "Please Enter PO Number";
                    if (checked) {
                        checked = false;
                    }
                }
               
                for(var index = 0; index < self.partsArr.length; index++) {
                    self.partsArr[index].qty_error = "";
                   
                    if (!self.partsArr[index].qty) {
                        self.partsArr[index].qty_error = "Please Enter Qty";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.partsArr[index].qty <= 0) {
                        self.partsArr[index].qty_error = "Please Enter Valid Qty";
                        if (checked) {
                            checked = false;
                        }
                    } else if (self.partsArr[index].qty && !self.allnumeric(self.partsArr[index].qty)) {
                        self.partsArr[index].qty_error = "Only Number Allowed";
                        if (checked) {
                            checked = false;
                        }
                    } else {
                        if (parseInt(self.partsArr[index].qty) > parseInt(self.partsArr[index].qoh) ) {
                            self.partsArr[index].qty_error = "Qty can't be greater than QOH";
                            if (checked) {
                                checked = false;
                            }
                        }
                    }
                }
                return checked;
            },

            addUpdateMultipleParts : function() {
                if (self.checkForm()) {
                    var config = {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("api_token")
                        },
                    };

                    var fields = {
                        po_number : self.poNumber,
                        selected_part_data_arr : self.partsArr,
                        tz: moment.tz.guess(),
                    };

                    HTTP.post("/store-multiple-part-depletion-history", fields, config)
                        .then(function (data) {
                            if (data.status == 200) {
                                self.resetCIMultiEditModel();
                                self.$refs['multy-order-part-modal'].hide();
                                self.loadInventory();
                                self.showSAlert('Part used successfully', 'success', false);
                            }
                        })
                        .catch(function (error) {
                            self.error_msg_login = "";
                            self.catchHandler(error);
                        })
                }
            },

            resetCIMultiEditModel : function() {
                self.poNumber = '';
                self.poNumberError = '';
                self.partsArr = [];
            },

            loadInventory: function() {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage);
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var customerId = 0;
                var strURL = "";
                if(localStorage.getItem("login_role") == 'user') {
                    customerId = localStorage.getItem("customer_id");
                    strURL = "user/inventory/list-inventory-parts";
                } else {
                    customerId = JSON.parse(localStorage.getItem('customer_obj')).id;
                    strURL = "inventory/list-inventory-parts";
                }
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                    params : {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        messageData: self.message,
                        sort: self.serverParams.sort,
                        tz: moment.tz.guess(),
                        customer_id: customerId,
                        is_website: true
                    }
                };
                // HTTP.get("inventory", config)
                HTTP.get(strURL, config)
                    .then(function(response) {
                        //console.log('inventory',response);
                        if (response.status == "200") {
                            // self.rows = response.data.inventory.data;
                            // self.totalRecords = response.data.totalRecords;
                            self.rows = response.data.content.row;
                            self.totalRecords = response.data.content.totalRecords;
                            self.totalExtCost = response.data.partExtCostTotal;
                            // $('.loading-container').hide();
                        }
                        self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                    })
                    .catch(function(err) {
                        console.log('err', err)
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.clear();
                                self.$router.push("/");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            }
        }
    };
    EventBus.$on("change-customer-dropdown-value", function(data) {
        if (typeof self != "undefined") {
            self.loadInventory();
        }
    });
</script>
<style scoped>
    /* .page-header-top-container.stick-inventory-header.TopFix {
        position: fixed;
        z-index: 9;
        background: #fff;
        top: 86px;
        border-top: 1px solid #ddd;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        padding: 20px 30px;
    }
    .page-header-top-container.stick-inventory-header.TopFix .page-title {
        font-size: 26px;
        line-height: 26px;
    }
    .page-header-top-container.stick-inventory-header.TopFix .ext-cost {
        margin: 2px 0 0 0;
    } */
    .multy-parts-model .col-form-label {
        font-weight: bold;
    }
    .multy-parts-model .form-input{
        position: relative;
    }
    .multy-parts-model .form-input .requiredstar{
        right:-12px;
    }
    .multy-parts-model .btn-plus {
        margin-top: 18%;
    }
    .multy-parts-model .qty-on-hand-lbl, .qty-on-hand-error{
        border-radius: 0 !important;
        border: none !important;
        text-align: left !important;
    }
    .partNoLbl {
        border: none;
        border-radius: 0;
    }
    .ci-model-btn{
        float:right;
    }
</style>


// WEBPACK FOOTER //
// src/components/Inventory/ListInventory.vue